import { DeliveryPackageStatus } from 'enums';
import { capitalise } from './Utility';

export function deliveryPackageStatusToFriendly(statusId: number) {
  switch (statusId) {
    case DeliveryPackageStatus.WAITING_FOR_PICKUP:
      return 'Waiting for pickup';
    case DeliveryPackageStatus.OUT_FOR_DELIVERY:
      return 'Out for delivery';
    case DeliveryPackageStatus.DELIVERED:
      return 'Delivered';
    case DeliveryPackageStatus.DELETED:
      return 'Deleted';
    default:
      return capitalise(DeliveryPackageStatus[statusId]);
  }
}
